<template>
  <div class="departemt-box">
    <commonTable
      :config="{nothing}"
      @button-click="addOnceTree"
      ref="commonTable"
      tableHead="department"
      :verifyRemark="$permission(['部门管理-新增部门','部门管理-更新部门','部门管理-删除部门'])"
      rowKey="depart_id"
      :isSelfMak="true"
      :lazy="true"
      :loade="load"
      :treeProps="{children: 'children', hasChildren: 'children_amount'}"
      :needPage="false"
      v-loading="loading"
      :selection="true"
      :popover="false"
      @handleSelectionChange="handleSelectionChange"
    >
      <template #table_head>
        <div class="search-table">
          <div class="search-table-tool">
            <!-- <el-input prefix-icon="iconfont iconicon_search1" @input="searchChange" class="fliter-input" v-model="filterText" size="mini" placeholder="搜索部门名称" clearable @keyup.enter.native="init"></el-input> -->

            <div class="btns">
              <wf-button type="primary" :icon="'icon iconfont iconicon_enlarge'" @click="addOnceTree" style="margin-right:12px;" v-permission="'部门管理-新增部门'">添加部门</wf-button>
              <wf-button type="primary" :icon="'icon iconfont iconicon_delete'" plain :disabled="depart_ids.length == 0 ? true : false" @click="adjustmentCheck" v-permission="'部门管理-删除部门'">删除部门</wf-button>
            </div>
            <!-- <el-input
              prefix-icon="iconfont iconicon_search1"
              @input="remoteMethod(filterText)"
              class="fliter-input"
              v-model="filterText"
              placeholder="搜索部门名称"
              clearable
            ></el-input> -->
            <el-select v-model="filterText" filterable remote reserve-keyword placeholder="搜索部门名称" :remote-method="remoteMethod" size="mini" clearable @change="searchChange">
              <template slot="prefix">
                <i class="icon iconfont iconicon_search1"></i>
              </template>
              <el-option v-for="item in options" :key="item.depart_id" :label="item.name" :value="item.depart_id">
              </el-option>
            </el-select>

          </div>
        </div>
      </template>
      <template slot="verifyRemark" slot-scope="scope">
        <!-- <span @click="addDepartment(scope.data)" v-permission="'部门管理-新增部门'">新增</span> -->

        <!-- <span @click="editDepartment(scope.data)" v-permission="'部门管理-更新部门'">修改</span> -->
        <!-- <span @click="delDepartment(scope.data)" v-permission="'部门管理-删除部门'">删除</span> -->

        <el-dropdown trigger="click" @command="handleCommand($event, scope.data)" placement="bottom">
          <i class="icon iconfont iconicon_more_task1 tableIconHover"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              icon="icon iconfont iconicon_input"
              command="edit"
              v-permission="'部门管理-更新部门'"
            >
              编辑信息
            </el-dropdown-item>
            <el-dropdown-item
              class="del"
              icon="icon iconfont iconicon_delete"
              command="del"
              v-permission="'部门管理-删除部门'"
            >
              删除部门
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>

      <template slot="department_header_user_info" slot-scope="scope">
        <div class="header-box" v-if="scope.data.department_administrators && scope.data.department_administrators.length > 0">
          {{ getDepartmentUsers(scope.data.department_administrators) }}
        </div>
        <span v-else>{{'-'}}</span>
      </template>
      <template slot="department_category" slot-scope="scope">
        <span>{{scope.data.department_category.name}}</span>
      </template>
    </commonTable>
    <el-drawer :title="isEdit ? '编辑部门':'新建部门'" :visible.sync="dialogVisible" :wrapperClosable="false" :append-to-body="true" size="500px">
      <addDialog @cancel="dialogVisible = false" @delDepartment="delDepartment" :visible="dialogVisible" :isEdit="isEdit" :parentDepartmentList="parentDepartmentList" :isParent="isParent" :dataset="dataset" @complete="complete" />
    </el-drawer>
  </div>
</template>
<script>
import api from '@/services/api/department/department'
import addDialog from './addDialog'
export default {
  components: {
    addDialog
  },
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      dataset: {},
      isEdit: false,
      isParent: false,
      loading: false,
      filterText: '',
      tableTreeData: [],
      templateSelection: '',
      parentDepartmentList: [],
      depart_ids: [],
      options: [],
      loading: false,
      nothing: {
        tip: '暂无部门，快去添加部门吧',
        type: 'img_add_task',
        btnText: '添加部门',
        permission: ''
      },
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    complete(parent_id, isParent) {
      // console.log(parent_id, isParent, 1111)
      this.dialogVisible = false
      this.isEdit = false
      this.isParent = false
      this.$emit('complete', parent_id, isParent, true)
      this.reafchDom(parent_id, isParent)
    },
    async init(pid) {
      this.loading = true
      await api.getDepartmentIndex({ pid: pid || 0, level: 1 }).then(res => {
        this.$refs.commonTable.ruleForm.pagData.number = 9999
        this.parentDepartmentList = JSON.parse(JSON.stringify(res.data))
        this.$refs.commonTable.selfPageSplit(this.parentDepartmentList)
      })
      this.loading = false
    },
    async reafchDom(parent_id, isParent) {
      await this.init()
      this.$nextTick(() => {
        this.loading = true
        return api.getDepartmentIndex({ pid: parent_id, level: 1 }).then(temp => {
          this.$set(this.$refs.commonTable.getTableRefs().store.states.lazyTreeNodeMap, parent_id, temp.data) // 刷新子节点
          this.loading = false
        }).catch(err => {
          this.loading = false
        })
      })

    },
    load(tree, treeNode, resolve) {
      // console.log(tree, 1111)
      api.getDepartmentIndex({ pid: tree.depart_id, level: 1 }).then(res => {
        tree.children = res.data
        resolve(res.data)
      })
    },
    addDepartment(data) {
      this.dataset = JSON.parse(JSON.stringify(data))
      this.dialogVisible = true
      this.isEdit = false
      this.isParent = false
    },
    handleCommand(command, data) {
      if (command === 'edit') {
        this.editDepartment(data)
      } else if (command === 'del') {
        this.delDepartment(data)
      }
    },
    async delDepartment(data) {
      await this.$wfAlert('warning', `确定删除部门${data.name}?`, '当前操作将删除该部门及其子部门，删除后不可恢复。请谨慎操作。')
      await api.deleteDepartment({ depart_ids: [data.depart_id] })
      await this.reafchDom(data.parent_id)
      this.dialogVisible = false
      this.$emit('complete')
      this.init()
      this.$message({ type: 'success', message: '删除成功!' });
    },
    editDepartment(data) {
      this.$emit('handleUpdateDepartment', data)
      // this.isEdit = true
      // this.dialogVisible = true
      // this.dataset = JSON.parse(JSON.stringify(data))
      // if (data.parent_id == 0) {
      //   this.isParent = true
      // } else {
      //   this.isParent = false
      // }
    },
    addOnceTree() {
      this.$emit('handleAddDepartment')
      // this.isParent = true
      // this.isEdit = false
      // this.dialogVisible = true
    },
    handleSelectionChange(val) {
      this.depart_ids = val.map(res => res.depart_id)
      // console.log(this.depart_ids, 111)
    },
    searchChange() {
      if (!this.filterText) {
        this.init()
        return
      }
      this.loading = true
      let temp = this.options.find(res => res.depart_id === this.filterText)
      api.getDepartmentIndex({ pid: temp.parent_id, level: 1 }).then(res => {
        this.$refs.commonTable.ruleForm.pagData.number = 9999
        let item = res.data.find(res => res.depart_id === this.filterText)
        this.$refs.commonTable.selfPageSplit([item])
      })
      this.loading = false
      // this.init(this.filterText)
    },
    async adjustmentCheck() {
      await this.$wfAlert('warning', `确定删除${this.depart_ids.length}个部门吗？`,'当前操作将删除该部门及其子部门，删除后不可恢复。请谨慎操作。' )
      await api.deleteDepartment({ depart_ids: this.depart_ids })
      this.$message({
        type: 'success',
        message: '批量删除成功!'
      });
      this.$refs.commonTable.selfPageSplit([])
      this.$emit('complete')
      this.init()
    },
    remoteMethod(query) {
      if (query !== '') {
        api.searchDepartment({ keyword: query }).then(res => {
          this.options = JSON.parse(JSON.stringify(res.data))
        }).catch(err => {
        })
      } else {
        this.options = []
        this.init()
      }
    },
    // 获取负责人列表
    getDepartmentUsers(data) {
      let str = ''
      data.forEach(item => {
        str += item.user.realname + '、'
      })

      const regex = /、([^、]*)$/
      return str.replace(regex, '')
    }
  }
}
</script>
<style lang="scss" src="./style.scss">
</style>
